import { Game } from "../../pkg";
import { MouseEventHandler, useCallback, useEffect, useRef } from "react";

import * as classes from "./Canvas.module.css";
import { height, width } from "../game";

interface CanvasProps {
    game: Game;

    sandBlobSize: number;
    sandwormBlobSize: number;
    sandwormLifetime: number;
}

export function Canvas(props: CanvasProps) {
    const { game, sandBlobSize, sandwormBlobSize, sandwormLifetime } = props;

    const scale = 4;

    const canvasRef = useRef<HTMLCanvasElement>(null);
    useEffect(() => {
        let id = window.requestAnimationFrame(render);

        function render() {
            game.render(canvasRef.current.getContext("2d"));
            id = window.requestAnimationFrame(render);
        }

        return () => {
            window.cancelAnimationFrame(id);
        };
    }, [game]);

    const handleClick = useCallback<MouseEventHandler<HTMLCanvasElement>>(
        (e) => {
            e.preventDefault();

            const cell =
                e.button === 0 ? "Sand" : { Sandworm: sandwormLifetime };
            const blobSize = e.button === 0 ? sandBlobSize : sandwormBlobSize;

            const canvasRect = canvasRef.current.getBoundingClientRect();
            const canvasX =
                ((e.clientX - canvasRect.x) * canvasRef.current.width) /
                canvasRect.width;
            const canvasY =
                ((e.clientY - canvasRect.y) * canvasRef.current.height) /
                canvasRect.height;
            game.add_blob(canvasX, canvasY, cell, blobSize);
        },
        [game, sandBlobSize, sandwormBlobSize, sandwormLifetime],
    );

    return (
        <canvas
            ref={canvasRef}
            className={classes.canvas}
            width={width}
            height={height}
            style={{
                width: width * scale,
                height: height * scale,
            }}
            onClick={handleClick}
            onContextMenu={handleClick}
        />
    );
}
